import Color from "ts-color-class";

export const colors = {
  primary: new Color("#E18B38"),
  // secondary: new Color("#059AAD"),
  white: new Color("#ffffff"),
  black: new Color("#3a3a3a"),
  gray: new Color("#696969"),
  darkPurple: new Color("#322336"),
  accentRed: new Color("#D04440"),
  accentOrange: new Color("#EA682E"),
  accentLightOrange: new Color("#FA9126"),
  textGray: new Color("#717685")
};
